import { Injectable, signal } from '@angular/core';
import { CatalogAssembly } from 'src/app/models/catalog-assembly';
import { CacheLoaderService } from './cache-loader.service';
import { Assembly } from 'src/app/models/assembly.model';
import { AssembliesService } from './assemblies.service';

@Injectable({
  providedIn: 'root'
})
export class CatalogService {

  catalogAssemblies= signal<CatalogAssembly[]>([]);
  selectedAssembly = signal<CatalogAssembly | null>(null);
  filteredCatalogAssemblies = signal<CatalogAssembly[]>([]);

  constructor(private assembliesService: AssembliesService) { }

  setSelectedAssembly(assembly: CatalogAssembly) {
    this.selectedAssembly.set(assembly);
  }

  clearSelectedAssembly() {
    this.selectedAssembly.set(null);
  }

  setAssemblies(assemblies: CatalogAssembly[]) {
    this.catalogAssemblies.set(assemblies);
  }

  searchAssemblies(searchTerm: string) {
    const filteredAssemblies = this.catalogAssemblies().filter(assembly => {
      const name = assembly.Name ? assembly.Name.toLowerCase() : '';
      const description = assembly.Description ? assembly.Description.toLowerCase() : '';
      return name.includes(searchTerm.toLowerCase()) || description.includes(searchTerm.toLowerCase());
    }).map(assembly => {
      return {
        ...assembly,
        Description: this.getHighlightedSnippet(assembly.Description, searchTerm)
      };
    });
    this.filteredCatalogAssemblies.set(filteredAssemblies);
  }

  getHighlightedSnippet(description: string, searchTerm: string): string {
    const term = searchTerm.toLowerCase();
    const index = description.toLowerCase().indexOf(term);
    if (index === -1) {
      return description;
    }

    const snippetLength = 90;
    const start = Math.max(0, index - Math.floor(snippetLength / 2));
    const end = Math.min(description.length, start + snippetLength);

    let snippet = description.substring(start, end);
    if (start > 0) {
      snippet = '...' + snippet;
    }
    if (end < description.length) {
      snippet = snippet + '...';
    }

    const highlightedSnippet = snippet.replace(new RegExp(`(${searchTerm})`, 'gi'), '<b>$1</b>');
    return highlightedSnippet;
  }

  getFullCatalog(fid: number) {
    this.assembliesService.getFullCatalog(fid).subscribe(assemblies => {
      this.setAssemblies(assemblies)
    }, error => {
      console.error('Error fetching categories: ', error);
    });
  }

  
}
